import { render } from "./ServicePromotionPanel.vue?vue&type=template&id=56e03998&scoped=true"
import script from "./ServicePromotionPanel.vue?vue&type=script&lang=js"
export * from "./ServicePromotionPanel.vue?vue&type=script&lang=js"

import "./ServicePromotionPanel.vue?vue&type=style&index=0&id=56e03998&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e03998"]])

export default __exports__